import { gql } from '@apollo/client'

export const {
  VERIFY_CODE,
  SEND_VERIFICATION_EMAIL,
  VALIDATE_ACCOUNT,
  SAVE_OAUTH_TOKEN,
  UPDATE_TWITTER_INFO,
  UPDATE_EMAIL,
  UPDATE_PASSWORD,
  UPDATE_PROFILE,
  UPDATE_CUSTOM_PROFILE_AVATAR,
  UPDATE_CUSTOM_PROFILE_WALLPAPER,
  GET_USER_PROFILE,
  GET_USER,
  GET_USER_GACHA_TICKET,
  GET_ITEMS,
  GET_TWITTER_INFO,
} = {
  VERIFY_CODE: gql`
    mutation($email: String!, $code: String!) {
      verifyCode(email: $email, code: $code) {
        verified
        id
      }
    }
  `,

  SEND_VERIFICATION_EMAIL: gql`
    mutation($email: String!) {
      sendVerificationEmail(email: $email) {
        id
      }
    }
  `,

  VALIDATE_ACCOUNT: gql`
    query($inputs: ValidateAccountInput) {
      validateAccount(inputs: $inputs) {
        email
        accountId
      }
    }
  `,
  SAVE_OAUTH_TOKEN: gql`
    mutation($inputs: SaveOauthTokenInput!) {
      saveOauthToken(inputs: $inputs) {
        ... on User {
          id
        }
        ... on Artist {
          id
        }
      }
    }
  `,
  UPDATE_TWITTER_INFO: gql`
    mutation updateTwitterInfo(
      $accountId: String
      $displayName: String
      $introduction: String
      $avatarPath: String
    ) {
      updateTwitterInfo(
        accountId: $accountId
        displayName: $displayName
        introduction: $introduction
        avatarPath: $avatarPath
      ) @client
    }
  `,
  UPDATE_EMAIL: gql`
    mutation UpdateEmail($email: String!, $password: String!) {
      updateEmail(email: $email, password: $password) @client
    }
  `,
  UPDATE_PASSWORD: gql`
    mutation UpdatePassword($old: String!, $new: String!, $confirm: String!) {
      updatePassword(
        oldPassword: $old
        newPassword: $new
        confirmPassword: $confirm
      ) @client
    }
  `,
  UPDATE_PROFILE: gql`
    mutation($inputs: UpdateProfileInput!) {
      updateProfile(inputs: $inputs) {
        ... on User {
          id
          accountId
          displayName
          avatar {
            uri
          }
          introduction
        }
      }
    }
  `,
  UPDATE_CUSTOM_PROFILE_AVATAR: gql`
    mutation($inputs: UpdateCustomProfileInput!) {
      updateCustomProfile(inputs: $inputs) {
        customProfile {
          avatarItemId
        }
      }
    }
  `,
  UPDATE_CUSTOM_PROFILE_WALLPAPER: gql`
    mutation($inputs: UpdateCustomProfileInput!) {
      updateCustomProfile(inputs: $inputs) {
        customProfile {
          wallpaperItemId
        }
      }
    }
  `,
  GET_USER_PROFILE: gql`
    query {
      user {
        id
        avatar {
          uri
        }
        displayName
        accountId
        introduction
      }
    }
  `,
  GET_USER: gql`
    query($id: ID) {
      user(id: $id) {
        id
        displayName
        gender
        avatar {
          uri
        }
        customProfile {
          avatarItem {
            id
            avatarResources {
              avatarResource {
                uri
              }
              voiceResource {
                uri
              }
            }
          }
          wallpaperItem {
            id
            resource {
              uri
            }
          }
        }
      }
    }
  `,
  GET_USER_GACHA_TICKET: gql`
    query($gachaTicketId: ID!) {
      user {
        id
        gachaTicket(id: $gachaTicketId) {
          available
        }
      }
    }
  `,

  GET_ITEMS: gql`
    query($type: ItemType) {
      portfolios(type: $type) {
        edges {
          node {
            ...Portfolio
          }
        }
      }
    }
    fragment Portfolio on UserItem {
      id
      isUsed
      item {
        id
        title
        thumbnail {
          front {
            uri
          }
        }
        resource {
          uri
        }
        avatarResources {
          avatarResource {
            uri
          }
          voiceResource {
            uri
          }
        }
      }
    }
  `,
  GET_TWITTER_INFO: gql`
    {
      twitterInfo @client {
        accountId
        displayName
        introduction
        avatarPath
      }
    }
  `,
}
